import React from "react";
import PropTypes from "prop-types";
import NeoLoader from "./NeoLoader";

const OverlayLoader = ({ show, label, zIndex }) => {
    return (
        <NeoLoader 
            type="overlay" 
            loading={show} 
            label={label} 
            style={zIndex ? { zIndex } : {}} 
        />
    );
};

OverlayLoader.propTypes = {
    show: PropTypes.bool,
    label: PropTypes.string,
    zIndex: PropTypes.number
};

export default OverlayLoader;

